import { createFileRoute } from '@tanstack/react-router';

import { getCompanyQueryOptions } from '@/_pages/companies/api-service';
import Loading from '@/_pages/companies/notes/loading';

export const Route = createFileRoute('/_private/companies/_template/$id/notes')({
  loader: (opts) => opts.context.queryClient.ensureQueryData(getCompanyQueryOptions(opts.params.id)),
  staticData: {
    pageTitle: 'Notes',
    tabKey: 'client/notes',
    isViewOnly: true,
    renderRightColumn: false,
    isFullWidth: true,
  },
  pendingComponent: Loading,
});
